// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"9fdabbff","647":"25ee3fc7"}[chunkId] + ".chunk.js";
};